import { request } from "../utils/request";
import { ref } from "@vue/composition-api";

const defaultConfig = {
  initQuery: {},
  api: "",
  auto: true,
  resetDataBeforeRequest: false,
};

export const useFetchItem = (config) => {
  const conf = Object.assign(defaultConfig, config);

  const isLoading = ref("false");
  const isError = ref(false);
  const data = ref({});
  const error = ref(null);
  const query = ref(conf.initQuery);

  const fetchData = () => {
    isLoading.value = false;
    conf.resetDataBeforeRequest && (data.value = []);
    request
      .get(conf.api, { params: query.value })
      .then((resp) => {
        if (resp.status < 300) {
          data.value = resp.data;
          error.value = null;
          isError.value = false;
        } else {
          data.value = [];
          error.value = new Error({
            message: resp.data.message || "Request Error",
          });
          isError.value = true;
        }
      })
      .catch((error) => {
        error.value = error;
        isError.value = true;
      })
      .finally(() => {
        isLoading.value = false;
      });
  };

  conf.auto && fetchData();

  return {
    fetchData,
    isLoading,
    data,
    error,
    query: query.value,
  };
};
